import type { ColocaStatusPillProps } from "@/shared/components/data-display/ColocaStatusPill";
import type { ClientsTranslations } from "@/shared/lang/interfaces/clients";

import type { IdentityType } from "../types/clients-api.types";

export const CLIENT_TYPE_CREATE_OPTIONS = ["B2C", "B2B"] as const;
export type CreateClientType = (typeof CLIENT_TYPE_CREATE_OPTIONS)[number] | "B2B2C";

/** Semantic `ColocaStatusPill` variant for the client/organization entity-type badge (no raw palette). */
export type TypeBadgeVariant = NonNullable<ColocaStatusPillProps["variant"]>;

export function getTypeBadgeVariant(type: IdentityType | CreateClientType | null): TypeBadgeVariant {
  switch (type) {
    case "individual":
    case "B2C":
      return "info";
    case "business":
    case "B2B":
      return "neutral";
    case "B2B2C":
      return "success";
    default:
      return "neutral";
  }
}

export function getTypeLabel(
  type: CreateClientType,
  t: (k: keyof ClientsTranslations, opts?: Record<string, unknown>) => string,
): string {
  switch (type) {
    case "B2C":
      return t("type_b2c");
    case "B2B":
      return t("type_b2b");
    case "B2B2C":
      return t("type_b2b2c");
    default:
      return type;
  }
}

export function getTableTypeLabel(
  type: CreateClientType,
  t: (k: keyof ClientsTranslations, opts?: Record<string, unknown>) => string,
): string {
  switch (type) {
    case "B2C":
      return t("table_type_individual");
    case "B2B":
      return t("table_type_empresa");
    case "B2B2C":
      return t("type_b2b2c");
    default:
      return type;
  }
}

export function displayClientName(item: {
  name?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  company_name?: string | null;
}): string {
  const rawName = item.name?.trim();
  if (rawName) return rawName;
  const company = item.company_name?.trim();
  if (company) return company;
  const first = item.first_name?.trim();
  const last = item.last_name?.trim();
  if (first || last) return [first, last].filter(Boolean).join(" ");
  return "—";
}

export function capitalizeIdentityType(type: IdentityType | null): string {
  if (!type) return "—";
  return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
}
